// Smart Daara - Tenant-aware routing helpers
// Every school-scoped route is prefixed with `/<tenantSlug>` so that URLs
// look like `sen-daara.com/<slug-ecole>/school/classes`.

/** Compute the base dashboard path for a user, prefixed with tenant slug when relevant. */
export const getDashboardPath = (user) => {
  if (!user) return '/login';
  const slug = user.tenant_slug;
  switch (user.role) {
    case 'super_admin':
      return '/admin';
    case 'school_admin':
    case 'manager':
    case 'censeur':
    case 'accountant':
      return slug ? `/${slug}/school` : '/school';
    case 'teacher':
      return slug ? `/${slug}/teacher` : '/teacher';
    case 'student':
      return slug ? `/${slug}/student` : '/student';
    case 'parent':
      return slug ? `/${slug}/parent` : '/parent';
    default:
      return '/login';
  }
};

/** Compute the base area (school, teacher, student, parent) for the current user. */
export const getUserArea = (user) => {
  if (!user) return null;
  switch (user.role) {
    case 'school_admin':
    case 'manager':
    case 'censeur':
    case 'accountant':
      return 'school';
    case 'teacher':
      return 'teacher';
    case 'student':
      return 'student';
    case 'parent':
      return 'parent';
    default:
      return null;
  }
};

/** Build a tenant-scoped path, e.g. buildTenantPath('daara', 'school/classes') -> '/daara/school/classes'. */
export const buildTenantPath = (slug, subPath = '') => {
  if (!slug) return `/${subPath.replace(/^\//, '')}`;
  const cleaned = subPath.replace(/^\//, '');
  return cleaned ? `/${slug}/${cleaned}` : `/${slug}`;
};
